import { instance } from '@/helpers/interceptors'

export const logoff = (appInfoStore: any) => {
  // clear pinia store state
  appInfoStore.resetAppInfo()

  // delete authorization httponly cookie
  instance().get('/App/Logoff')
}
